import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
import AddContentBody from '../Body';
export var AddContentModal = /*#__PURE__*/function (_Component) {
  function AddContentModal() {
    _classCallCheck(this, AddContentModal);
    return _callSuper(this, AddContentModal, arguments);
  }
  _inherits(AddContentModal, _Component);
  return _createClass(AddContentModal, [{
    key: "cancelButton",
    value: function cancelButton() {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.closeModal
      }, t('Cancel'));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/React.createElement(AddContentBody, {
        allowStimulusCreation: this.props.allowStimulusCreation,
        onOpenBankTray: this.props.closeModal,
        onAddItem: this.props.closeModal,
        parentEntryId: this.props.parentEntryId,
        position: this.props.position,
        quizId: this.props.quizId,
        showHeaderText: false,
        stimulusId: this.props.stimulusId
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.props.closeModal,
        size: "large",
        label: t('Add Content')
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
        level: "reset",
        as: "h2"
      }, t('Insert Content')), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.props.closeModal,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(ModalBody, null, this.renderContent()), /*#__PURE__*/React.createElement(ModalFooter, null, this.cancelButton())));
    }
  }]);
}(Component);
_defineProperty(AddContentModal, "propTypes", {
  allowStimulusCreation: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  parentEntryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  quizId: PropTypes.string.isRequired,
  stimulusId: PropTypes.string
});
_defineProperty(AddContentModal, "defaultProps", {
  parentEntryId: void 0,
  stimulusId: void 0
});
export default AddContentModal;